// extracted by mini-css-extract-plugin
export default {"layout":"_1b903ab440 b5922f4702 _21a5a58e33","h_slide":"b50f62dd6b","category":"_1931a46884 _01e37c831e _37dfea912e"};